export default "__VITE_ASSET__3395e9f9__"